export default "__VITE_ASSET__CGuIoT7a__"